export default function initAudioPlayer() {
  Alpine.data('audioPlayer', () => ({
    audio: null as HTMLAudioElement | null,
    progressBar: null as HTMLElement | null,
    playing: false,
    initPlayer(id: string) {
      this.audio = document.querySelector(`#audio-player-${id}`);
      this.progressBar = document.querySelector(`#progress-bar-${id}`);
      if (this.audio) {
        this.audio.addEventListener('ended', () => {
          this.playing = false;
        });
        if (this.audio && this.progressBar) {
          this.audio.addEventListener('timeupdate', () => {
            if (this.audio && this.progressBar) {
              const value = (this.audio.currentTime / this.audio.duration) * 100;
              this.progressBar.style.width = `${value || 0}%`;
            }
          });
        }
      }
    },
    togglePlay() {
      if (this.audio) {
        if (this.audio.paused) {
          this.audio.play();
          this.playing = true;
        } else {
          this.audio.pause();
          this.playing = false;
        }
      }
    },
  }));
}
